module.exports = __webpack_public_path__ + "img/Primordial-Process-4.3e474106.png";